import React from 'react';
import { ArrowRight, CheckCircle2, Globe, ShieldCheck, Zap, Beaker, Rocket } from 'lucide-react';

function WhyTBIF() {
  return (
    <section className="relative py-24 px-6 bg-slate-50 overflow-hidden">
      {/* Background Pattern - Adds technical texture */}
      <div className="absolute inset-0 bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] [background-size:20px_20px] opacity-70"></div>
      
      {/* Ambient Glow - Adds depth behind the cards */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/4 w-[500px] h-[500px] bg-blue-400/20 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        
        {/* Left Content */}
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-blue-100 text-blue-700 rounded-full text-xs font-bold uppercase tracking-widest mb-8 shadow-sm">
              <Rocket size={14} className="text-blue-600" /> 
              <span>DST Recognized</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-[1.15]">
            Empowering <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
              Deep-Tech Innovations
            </span>
          </h2>
          
          <p className="text-slate-600 text-lg leading-relaxed mb-8 max-w-lg">
            We are a Section-8 Not-for-Profit organization set up under the <strong>NIDHI-TBI scheme</strong> of DST, Govt of India. We bridge the critical gap between academic research and commercial market success.
          </p>
          
          <div className="space-y-5 mb-10">
             <CheckItem text="State-of-the-art Lab Infrastructure (20k sq. ft)" />
             <CheckItem text="Seed Funding up to ₹50 Lakhs & Investor Connects" />
             <CheckItem text="Deep-Tech Mentorship from IIT Faculty" />
             <CheckItem text="IP, Legal, Compliance & CA Support" />
          </div>

          <a href="tbif/about" className="group inline-flex items-center gap-3 px-6 py-3 bg-slate-900 text-white rounded-xl font-semibold hover:bg-blue-600 transition-all duration-300 shadow-lg hover:shadow-blue-500/25">
            More about our Mission 
            <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"/>
          </a>
        </div>

        {/* Right Grid (Leveled Layout) */}
        {/* Changed to a flat grid so all items align perfectly */}
        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
            <ValueCard 
               icon={<Zap className="w-6 h-6 text-white"/>}
               iconBg="bg-amber-500"
               title="Acceleration"
               desc="Fast-track growth with structured 3-month cohort programs."
            />
            <ValueCard 
               icon={<Globe className="w-6 h-6 text-white"/>}
               iconBg="bg-blue-500"
               title="Global Network"
               desc="Access to industry giants, 180+ mentors, and global VCs."
            />
            <ValueCard 
               icon={<ShieldCheck className="w-6 h-6 text-white"/>}
               iconBg="bg-emerald-500"
               title="Defence CoE"
               desc="Specialized support for Cybersecurity, AI & Drone Tech."
            />
            <ValueCard 
               icon={<Beaker className="w-6 h-6 text-white"/>}
               iconBg="bg-purple-500"
               title="Prototyping Labs"
               desc="Advanced IoT, Manufacturing & Fabrication facilities."
            />
        </div>

      </div>
    </section>
  );
}

// --- SUB-COMPONENTS ---

const CheckItem = ({ text }) => (
    <div className="flex items-start text-slate-700 group">
        <div className="mt-1 flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 mr-3 shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
            <CheckCircle2 size={12} strokeWidth={3} />
        </div>
        <span className="font-medium text-base">{text}</span>
    </div>
);

const ValueCard = ({ icon, iconBg, title, desc }) => (
    <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-lg shadow-slate-200/50 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1 transition-all duration-300 group cursor-default h-full">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 shadow-md ${iconBg} transform group-hover:scale-110 transition-transform duration-300`}>
            {icon}
        </div>
        <h4 className="font-bold text-slate-900 text-lg mb-2 group-hover:text-blue-600 transition-colors">{title}</h4>
        <p className="text-sm text-slate-500 leading-relaxed">{desc}</p>
    </div>
);

export default WhyTBIF;